import { ButtonHTMLAttributes, FunctionComponent } from 'react';
import { Link, LinkProps } from 'react-router-dom';
import classNames from 'classnames';
import './Button.scss';

interface ClassProps {
  className?: string;
  disabled?: boolean;
  light?: boolean;
  dark?: boolean;
  text?: boolean;
  small?: boolean;
  medium?: boolean;
}

const getAttributes = <PropsType extends ClassProps>({
  className,
  disabled,
  light,
  dark,
  text,
  small,
  medium,
  ...attributes
}: PropsType) => {
  return Object.assign(attributes, {
    disabled,
    className: classNames([
      'sprd-button',
      className,
      {
        'sprd-button--disabled': disabled,
        'sprd-button--light': light,
        'sprd-button--dark': dark,
        'sprd-button--text': text,
        'sprd-button--small': small,
        'sprd-button--medium': medium,
      },
    ]),
  });
};

export const Button: FunctionComponent<ButtonHTMLAttributes<HTMLButtonElement> & ClassProps> = (
  buttonProps
) => (
  <button
    type="button" /* default type can be overwritten by props */
    {...getAttributes(buttonProps)}
  />
);

export const ButtonLink: FunctionComponent<LinkProps & ClassProps> = (linkProps) => (
  <Link {...getAttributes(linkProps)} />
);
